<template>
    <div class="row header">
        <router-link :to="{ name: 'projects-index' }" class="col-sm-2">
            <img src="@images/dotag-logo.png" alt="">
        </router-link>
        <div class="col-sm-10">
            <div class="header-menu">
                <!--<a href="" class="back-link">Back</a>-->
                <!--<span class="icon support"></span>-->
                <!--<span class="icon box"></span>-->

                <div v-if="$store.state.company.id">
                    <router-link :to="{ name: 'company-users-index', params: { company_id : $store.state.company.id }}"
                        class="icon settings">
                    </router-link>
                </div>

                <div class="btn-group">
                    <b-dropdown :text="(user && user.name) ?  'Hello ' + user.name : 'Menu'"
                                toggle-class="text-decoration-none"
                                variant="none"
                                size="sm">
                        <b-dropdown-item @click="$emit('logout')">Logout</b-dropdown-item>
                    </b-dropdown>
                    
                    <!-- Impersonation Dropdown for Super Admins -->
                    <ImpersonationDropdown />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import idb from "@mobile/store/idb";
    import EventBus from '../../eventBus';
    import '@css/settings-create-project.css';
    import ImpersonationDropdown from './ImpersonationDropdown.vue';

    export default {
        components: {
            ImpersonationDropdown
        },
        data() {
            return {
                user: null,
                companyID: null
            }
        },
        mounted() {
            idb.getUser().then(r => {
                // The cached user can belong to an earlier session (token handed over after a
                // password reset, impersonation) — prefer the user loaded for the current token.
                this.user = this.sessionUser() || r;
            });

            EventBus.$on('user-loaded', this.onUserLoaded);

            this.companyID = this.$store.state.company.id;
        },
        beforeDestroy() {
            EventBus.$off('user-loaded', this.onUserLoaded);
        },
        methods: {
            // The user loaded for the current token (App.vue), if it is there yet.
            sessionUser() {
                const user = this.$store.state.user;

                return user && user.id ? user : null;
            },
            onUserLoaded(user) {
                if (user && user.id) {
                    this.user = user;
                }
            }
        }
    }
</script>
